import React from 'react'
import PropTypes from 'prop-types'
// import PhoneInput from 'react-phone-number-input'
// import SmartInput from 'react-phone-number-input/smart-input'
// import flags from 'react-phone-number-input/flags'
// import 'react-phone-number-input/style.css'
import 'styles/d3/phonenumberinput.scss'
import IntlTelInput from 'react-intl-tel-input'
import 'react-intl-tel-input/dist/main.css'

// PhoneInput component commented out, but kept as fallback option

const PhoneNumberInput = props => {
  const {
    className,
    errorText,
    hasError,
    onBlur,
    onChange,
    // onCountryChange,
    // value,
  } = props

  const _className = `${className ? ` ${className}` : ''}${
    hasError ? ' has-error' : ''
  }`

  const defaultCountry = navigator.language.split('-')[1] || 'US'

  return (
    <div className={`phone-number-input${_className}`}>
      {/* <PhoneInput
        displayInitialValueAsLocalNumber
        international={false}
        tabIndex={0}
        inputComponent={SmartInput}
        countryOptions={['US', 'IT', 'JP']}
        onChange={onChange}
        limitMaxLength
        value={value}
        flags={flags}
        country={defaultCountry || 'US'}
        onCountryChange={onCountryChange}
      /> */}
      <IntlTelInput
        autoHideDialCode
        defaultCountry={defaultCountry.toLowerCase()}
        format
        onPhoneNumberBlur={onBlur}
        onPhoneNumberChange={onChange}
        preferredCountries={['US', 'IT', 'JP']}
        separateDialCode
      />
      {hasError && errorText && <span className='error-text'>{errorText}</span>}
    </div>
  )
}

PhoneNumberInput.propTypes = {
  className: PropTypes.string,
  errorText: PropTypes.string,
  hasError: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  // onCountryChange: PropTypes.func,
  // value: PropTypes.string,
}

export default PhoneNumberInput



// WEBPACK FOOTER //
// ./src/components/PhoneNumberInput.js